import { render, staticRenderFns } from "./AsociarClientesProveedor.vue?vue&type=template&id=0f990316&"
import script from "./AsociarClientesProveedor.vue?vue&type=script&lang=ts&"
export * from "./AsociarClientesProveedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports